import React from "react";
import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs/internal/Observable";
import { catchError, map, switchMap} from "rxjs/operators";
import { IRESTContext, IToken } from "../common/common.models";
import { BasicAuthPassword, calls, COOKIES, PROJECT_KEY } from "./APIUtils";
import {getBrowserInfo} from "../common/constants"

export const RESTContext = React.createContext<IRESTContext>(null!);


export const AWSlogger = (log:any) => {
  try{
    ajax({
      url: calls.Project.sendLog().url,
      method: calls.Project.sendLog().method,
      headers: { "Content-Type": "application/json" },
      body: { ...log, projectKey: PROJECT_KEY }
    }).subscribe({ error: () => {} })
  }catch(err){}
}

export const RESTContextComponent = (props: any) => { 

  const [token, setToken] = React.useState<IToken | null>(COOKIES.get("cookie_access_token") || null)

  /* === FUNZIONI === */
  const ajaxMiddleware$ = (call: any, token_ = token, body = {}): Observable<any> => {
    const complex$ = ajax({
      url: `${call.url}`,
      method: call.method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${token_?.token_type || "Basic"} ${token_?.access_token || BasicAuthPassword}`
      },
      body: body
    });
    return complex$.pipe(
      map(e => e.response),
      catchError((err) => {
        throw err;
      })
    );
  };

  const ajax$ = (call: any, token_ = token, body = {}, async= true, contentType: string = "application/json"): Observable<any> => {
      if(!token_ && COOKIES){
          token_ = COOKIES.get("cookie_access_token")
      }
      const complex$ = ajax({
      url: `${call.url}`,
      method: call.method,
      headers: {
        "Content-Type": contentType,
        "Authorization": `${token_?.token_type || "Basic"} ${token_?.access_token || BasicAuthPassword}`
      },
      body: body,
      async: async
    });
    return complex$.pipe(
      map(e => e.response),
      catchError((err) => {
        if (err.status === 401) {
          return refreshToken(call, body);
        } else if (err.status !== 403) {
            if (err.response && err.response.statusCode && err.response.message){
                let statusCode = err.response.statusCode
                let errMsg = err.response.message
                if((statusCode !== 400 && !errMsg.endsWith("does not have a shipping address set.")) ||
                    (statusCode !== 400 && "No active cart exists." !== errMsg)){

                    AWSlogger({
                        type: "log",
                        action: "ajax",
                        url: `${call.url}`,
                        method: call.method,
                        body: body,
                        request: err.request,
                        response: err.response,
                        browserInfo: getBrowserInfo()
                    })
                }
            }
        }
        throw err;
      })
    );
  };

  const ajaxBRX$ = (call: any, token_: { token_type: any; access_token: any; }, body = {}, async= true, contentType: string = "application/json"): Observable<any> => {
    const complex$ = ajax({
      url: `${call.url}`,
      method: call.method,
      headers: {
        "Content-Type": contentType,
        ...( token_ ? {"Authorization": `${token_?.token_type || "Basic"} ${token_?.access_token || BasicAuthPassword}`} : {})
      },
      body: body,
      async: async
    });
    return complex$.pipe(
      map(e => e.response),
      catchError((err) => {
      
      AWSlogger({
          type: "log",
          action: "ajaxBRX",
          url: `${call.url}`,
          method: call.method,
          body: body,
          request: err.request,
          response: err.response,
          browserInfo: getBrowserInfo()
      })
               
      throw err;
      })
    );
  };

  const refreshToken = (call: any, body: any) => {
    const complex$ = ajax({
      url: calls.Authorization.refreshToken(token?.refresh_token || "").url,
      method: calls.Authorization.refreshToken(token?.refresh_token || "").method,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Basic ${BasicAuthPassword}`
      },
      body: {}
    });
    return complex$.pipe(
      map(e => e.response),
      catchError((err) => {
        setToken(null);
        throw err;
      }),
      switchMap((res) => {
        if (!res.errors) {
          setToken(res);
          return ajax$(call, res, body);
        }
        return new Observable();
      }),
    );
  };

  const getAnonymousToken = () => {
    ajax$(calls.Authorization.getAnonymousToken(), {
        access_token: null,
        token_type: null,
    }).subscribe((res: any) => setToken(res));
  };


  return (
    <RESTContext.Provider value={{
      token,
      setToken,
      ajax$,
      ajaxBRX$,
      ajaxMiddleware$,
      getAnonymousToken,
      AWSlogger

    }}>
      {props.children}
    </RESTContext.Provider>
  );
};